import {Button, Text} from "@mantine/core";
import { QuoteVersionCreateForm } from "./quote-version.create.form";
import { useModals } from "@mantine/modals";
import { Plus } from "tabler-icons-react";

interface Props {
    onSubmitForm:(values:any) => void,
}

export function QuoteVersionCreateButton({ onSubmitForm }:Props) {
    const modals = useModals();

    async function _onSubmitForm(values:any){
        await onSubmitForm(values);
        modals.closeAll();
    }

    const renderQuoteVersionForm = () => {
        modals.openModal({
            withCloseButton:true,
            closeOnClickOutside:true,
            closeOnEscape:true,
            size:"900",
            overflow:'outside',
            title: (
                <Text size={'xl'}>Create New Quote Version</Text>
            ),
            children: (
                <QuoteVersionCreateForm onSubmitQuery={_onSubmitForm}/>
            ),
        })
        return false;
    }

    return (
        <Button leftIcon={<Plus size={18}/>} onClick={renderQuoteVersionForm}>
            New Quote Version
        </Button>
    )
}
